<template>
    <div class="mc-report-view__table">
      <div class="row">
        <!-- Search -->
        <div class="col-md-12">
          <div class="mc-table-view">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
              <label class="d-inline-flex align-items-center mc-table-view__search">
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter" debounce="500"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>
  
      <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-card>
              <b-skeleton-table
                :rows="3"
                :columns="fields.length"
                :table-props="{ bordered: false, striped: true }"
              >
              </b-skeleton-table>
            </b-card>
          </template>
          <b-table
            class="datatables"
            :items="listData"
            :fields="fields"
            responsive="md"
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :filter="filter"
            :filter-included-fields="filterOn"
          >

            <template #cell(licensePlate)="data">
              {{ data.item.licensePlate ? data.item.licensePlate : '-' }}
            </template>
  
            <template #cell(vehicleType)="data">
              {{ data.item.vehicleType ? data.item.vehicleType : '-' }}
            </template>
  
            <template #cell(area)="data">
              {{ data.item.area ? data.item.area : '-' }}
            </template>
  
            <template #cell(distance)="data">
              {{ data.item.distance ? data.item.distance : '0' }}
            </template>
  
            <template #cell(workDays)="data">
              {{ data.item.workDays ? data.item.workDays : '0' }}
            </template>

            <template #cell(workHours)="data">
              {{ data.item.workHours ? data.item.workHours : '00:00:00' }}
            </template>

            <template #cell(workHoursAvg)="data">
              {{ data.item.workHoursAvg ? data.item.workHoursAvg : '00:00:00' }}
            </template>
            
            <template #cell(parkingHours)="data">
              {{ data.item.parkingHours ? data.item.parkingHours : '00:00:00' }}
            </template>

            <template #cell(movingWorkHours)="data">
              {{ data.item.movingWorkHours ? data.item.movingWorkHours : '00:00:00' }}
            </template>

            <template #cell(movingHours)="data">
              {{ data.item.movingHours ? data.item.movingHours : '00:00:00' }}
            </template>

          </b-table>
        </b-skeleton-wrapper>
      </div>
      <div class="row mt-3" v-if="fields.length > 0">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Menampilkan
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              >
              </b-form-select>
              entri.
              <p>
                Menampilkan
                <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
                - <strong>{{ Math.min( (currentPage - 1) * perPage + reportSummaryMonthVehicle.ReportSummaryMonthVehicle.length, currentPage * perPage, totalRows) }}</strong> dari
                <strong>{{ totalRows }}</strong>
              </p>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows == null ? rows : totalRows"
                :per-page="perPage"
                @change="changePage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { GET_REPORT_SUMMARY_MONTH_BY_VEHICLE } from '@/services/api/report/report'
  import moment from 'moment'
  import { Helper } from '@/mixin/helper'
  import { Export } from '@/mixin/export'
  import { EXPORT_EXCEL_REPORT_SUMMARY_MONTH_BY_VEHICLE } from '@/services/api/report/excel'
  import { EXPORT_PDF_REPORT_SUMMARY_MONTH_BY_VEHICLE } from '@/services/api/report/pdf'
  moment.locale('id')
  
  export default {
    name: 'SummaryMonthVehicleTable',
    mixins: [Helper, Export],
    data() {
      return {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        reportSummaryMonthVehicle: {
            ReportSummaryMonthVehicle: [],
        },
        fields: [],
        isLoading: false,
        fileName: '',
        openSection: false,
        periode: [],
        filteredItems: [],
        month:'',
        year:'',
        vehicles: [],
      }
    },
    watch:{
        perPage: function(val){
            this.currentPage = 1
            this.perPage = val
            this.refreshData()
        },
        filter: function(val){
            this.filter = val
            this.refreshData()
        },
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.reportSummaryMonthVehicle.ReportSummaryMonthVehicle.length
      },
      listData() {
        return this.reportSummaryMonthVehicle.ReportSummaryMonthVehicle
      },
    },
    mounted() {
      // Set the initial number of items
      this.totalRows = this.reportSummaryMonthVehicle.ReportSummaryMonthVehicle.length
    },
    methods: {
      /**
       * Search the table data with search input
       */
  
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.filteredItems = filteredItems
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
      refreshData() {
        if (this.fields.length == 0) {
          this.reportSummaryMonthVehicle.ReportSummaryMonthVehicle = []
          return
        }
        this.fields = this.fields
        this.isLoading = true

        var filterVar = {
          year: Number(this.year),
          month: Number(this.month),
          pagination:{
            page: this.currentPage,
            show: this.perPage,
          },
          vehicleId:(this.vehicles.length>0)?this.vehicles:null,
          filter:(this.filter !== null && this.filter !== undefined && this.filter.length > 0)?this.filter:''
        }
  
        var self = this
        var getData = this.$apollo
          .query({
            query: GET_REPORT_SUMMARY_MONTH_BY_VEHICLE,
            variables: {
              filter: filterVar,
            },
            fetchPolicy: 'no-cache',
          })
          .then((res) => {
            var data = res.data
            self.totalRows = data.SummaryMonthByVehicle.ReportSummaryMonthVehicle.pagination.total
            if (data.SummaryMonthByVehicle.ReportSummaryMonthVehicle.data.length === 0) {
              self.reportSummaryMonthVehicle.ReportSummaryMonthVehicle = []
              self.isLoading = false
              return []
            }
            self.isEmpty = false
  
            self.reportSummaryMonthVehicle.ReportSummaryMonthVehicle =
              data.SummaryMonthByVehicle.ReportSummaryMonthVehicle.data
            self.filteredItems = data.SummaryMonthByVehicle.ReportSummaryMonthVehicle.data
  
            self.isLoading = false
            console.log(this.listData)
          })
  
        return getData
      },
  
      openTable(periode, filter, fields) {
        let splittedPeriod = periode
        if(typeof splittedPeriod == 'string'||splittedPeriod instanceof String){
          splittedPeriod = splittedPeriod.split('-')
        }
        this.month = splittedPeriod[1]
        this.year = splittedPeriod[0]
        this.vehicles = filter
        this.fields = fields
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshData()
            this.openSection = false
          }, 500)
        })
      },

      changePage(page) {
      this.currentPage = page
      this.refreshData()
    },
  
      downloadToExcel(periode, vehicles, fields) {
        let splittedPeriod = periode
        if(typeof splittedPeriod == 'string'||splittedPeriod instanceof String){
          splittedPeriod = splittedPeriod.split('-')
        }

        var filterVar = {
          year: Number(splittedPeriod[0]),
          month: Number(splittedPeriod[1]),
          column: fields.map((item) => item.header),
          vehicleId:(vehicles.length>0)?vehicles:null,
          filter:(this.filter !== null && this.filter !== undefined && this.filter.length > 0)?this.filter:''
        }
  
        var downloadProgress = {
          name:
            'Pemantauan Bulanan Kendaraan ' +
            moment(periode[0]).format('MMMM YYYY') +
            '.xlsx',
          periode: moment(periode[0]).format('MMMM YYYY'),
          downloadedAt: moment().format('DD MMMM YYYY HH:mm:ss'),
          subtitle: `Periode : ${moment(periode[0]).format('MMMM YYYY')}`,
          percentage: 0,
          type: 'excel',
        }
        this.$store.commit('report/saveProgress', downloadProgress)
  
        var percentage = 0
        var intervalDownload = setInterval(() => {
          if (percentage < 75) {
            percentage += 25
          } else if (percentage == 75) {
            percentage = 90
          } else if (percentage == 90) {
            clearInterval(intervalDownload)
          }
          this.$store.commit('report/updateProgress', {
            progress: downloadProgress,
            percentage: percentage,
          })
        }, 500)
  
        var self = this
        this.$apollo
          .query({
            query: EXPORT_EXCEL_REPORT_SUMMARY_MONTH_BY_VEHICLE,
            variables: {
              filter: filterVar,
            },
            fetchPolicy: 'no-cache',
          })
          .then((res) => {
            var isSuccessful = res.data.excelReportSummaryMonthVehicle.isSuccessful
            if (isSuccessful) {
              clearInterval(intervalDownload)
              self.$parent.$parent.$parent.refreshDownloadHistory()
              setTimeout(() => {
                self.$store.commit('report/updateProgress', {
                  progress: downloadProgress,
                  percentage: 100,
                })
                self.$store.commit('report/deleteProgress', downloadProgress)
              }, 500)
            } else {
              clearInterval(intervalDownload)
              self.$parent.$parent.$parent.refreshDownloadHistory()
              setTimeout(() => {
                self.$store.commit('report/updateProgress', {
                  progress: downloadProgress,
                  percentage: 90,
                })
                self.$store.commit('report/deleteProgress', downloadProgress)
              }, 500)
            }
          })
      },
  
      downloadToPdf(periode, vehicles, fields) {
        let splittedPeriod = periode
        if(typeof splittedPeriod == 'string'||splittedPeriod instanceof String){
          splittedPeriod = splittedPeriod.split('-')
        }

        var filterVar = {
          year: Number(splittedPeriod[0]),
          month: Number(splittedPeriod[1]),
          column: fields.map((item) => item.header),
          vehicleId:(vehicles.length>0)?vehicles:null,
          filter:(this.filter !== null && this.filter !== undefined && this.filter.length > 0)?this.filter:''
        }
  
        var downloadProgress = {
          name:
            'Pemantauan Bulanan Kendaraan ' +
            moment(periode[0]).format('MMMM YYYY') +
            '.pdf',
          periode: moment(periode[0]).format('MMMM YYYY'),
          downloadedAt: moment().format('DD MMMM YYYY HH:mm:ss'),
          subtitle: `Periode : ${moment(periode[0]).format('MMMM YYYY')}`,
          percentage: 0,
          type: 'pdf',
        }
        this.$store.commit('report/saveProgress', downloadProgress)
  
        var percentage = 0
        var intervalDownload = setInterval(() => {
          if (percentage < 75) {
            percentage += 25
          } else if (percentage == 75) {
            percentage = 90
          } else if (percentage == 90) {
            clearInterval(intervalDownload)
          }
          this.$store.commit('report/updateProgress', {
            progress: downloadProgress,
            percentage: percentage,
          })
        }, 500)
  
        var self = this
        this.$apollo
          .query({
            query: EXPORT_PDF_REPORT_SUMMARY_MONTH_BY_VEHICLE,
            variables: {
              filter: filterVar,
            },
            fetchPolicy: 'no-cache',
          })
          .then((res) => {
            var isSuccessful = res.data.pdfReportSummaryMonthVehicle.isSuccessful
            if (isSuccessful) {
              clearInterval(intervalDownload)
              self.$parent.$parent.$parent.refreshDownloadHistory()
              setTimeout(() => {
                self.$store.commit('report/updateProgress', {
                  progress: downloadProgress,
                  percentage: 100,
                })
                self.$store.commit('report/deleteProgress', downloadProgress)
              }, 500)
            } else {
              clearInterval(intervalDownload)
              self.$parent.$parent.$parent.refreshDownloadHistory()
              setTimeout(() => {
                self.$store.commit('report/updateProgress', {
                  progress: downloadProgress,
                  percentage: 90,
                })
                self.$store.commit('report/deleteProgress', downloadProgress)
              }, 500)
            }
          })
      },
    },
  }
  </script>
  